import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Card } from '@factorialco/f0-react'
import { Carousel } from '@factorialco/f0-react/dist/experimental'
import { AlertCircleLine } from '@factorialco/f0-react/icons/app'
import { ModulesDatoModule } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useModuleAvailabilities } from 'modules/core/hooks/useModuleAvailabilities'
import { track } from 'modules/core/lib/Tracking'
import { trackingEvents } from 'modules/core/lib/Tracking/events'
import i18n from 'modules/core/lib/i18n'

import { useGetDatoModules } from 'modules/marketplace_modules/hooks/useGetDatoModules'
import { useMarketplaceModulesPath } from 'modules/marketplace_modules/hooks/useMarketplaceModulesPath'
import { getDatoLocale } from 'modules/onboarding/lib/datoLocale'

const ModulesSection = ({ origin }: { origin?: string }) => {
  const navigate = useNavigate()
  const { getDetailPath } = useMarketplaceModulesPath()
  const {
    access: { locale: accessLocale },
  } = useCurrentSession()

  const locale = getDatoLocale(accessLocale)
  const { data: moduleData } = useGetDatoModules({
    locale: locale,
  })

  const { moduleAvailabilities } = useModuleAvailabilities()

  const isModuleUnavailable = (chargebeeModuleName: string) => {
    const availableModule = moduleAvailabilities.filter((obj) => {
      const modulesArray = chargebeeModuleName?.split(',')
      return modulesArray?.includes(obj.id)
    })[0]

    return !(availableModule?.available ?? false)
  }

  const [modulesUnavailable, setModulesUnavailable] = useState<ModulesDatoModule[]>([])

  useEffect(() => {
    if (moduleData) {
      const unavailableModules: ModulesDatoModule[] = []
      moduleData.forEach((module) => {
        const unavailableModule = isModuleUnavailable(module.chargebeeModuleName || '')
        if (unavailableModule) {
          unavailableModules.push(module)
        }
      })
      setModulesUnavailable(unavailableModules)
    }
  }, [moduleData])

  return (
    modulesUnavailable.length > 0 && (
      <Box gap="s24">
        <Carousel showArrows showDots columns={{ default: 2 }}>
          {modulesUnavailable?.map((module) => (
            <Box key={module.id} className="max-w-[263px]">
              <F0Card
                compact
                onClick={() => {
                  track(trackingEvents.upsell.clickModuleCard, {
                    component: 'launches_with_ceo_banner_section',
                    module: module.name,
                  })
                  navigate(getDetailPath(module.slug, origin ? `upsell_origin=${origin}` : undefined))
                }}
                key={module.id}
                image={module.thumbnailImage?.url || ''}
                title={module.name || ''}
                description={module.shortDescription || ''}
                metadata={[
                  {
                    icon: AlertCircleLine,
                    property: {
                      type: 'status',
                      value: {
                        label: i18n.t('marketplace.revamp.not_in_your_plan'),
                        status: 'neutral',
                      },
                    },
                  },
                ]}
              />
            </Box>
          ))}
        </Carousel>
      </Box>
    )
  )
}
export default ModulesSection
